export const PHONE_SHELL_NAV = [
  { key: "your-tasks", label: "Your Tasks", to: "/your-stuff/tasks" },
  { key: "profile", label: "Profile", to: "/your-stuff/profile" },
];

const trimTrailingSlash = (path) => (path.length > 1 ? path.replace(/\/+$/, "") : path);

export const isPhoneShellRoute = (path) => {
  if (typeof path !== "string") return false;
  const normalized = trimTrailingSlash(path);
  return PHONE_SHELL_NAV.some(({ to }) => normalized === to || normalized.startsWith(`${to}/`));
};
